import React, { memo } from 'react'
import { usePricingItem, PricingItemProps } from './usePricingItem'
import styles from './PricingItem.module.scss'

const PricingItem: React.FC<PricingItemProps> = (props: PricingItemProps) => {
  const {
    planName,
    icon,
    cost,
    description,
    btnLabel,
    features,
    isFeatured,
    onSubscribeClick,
  } = usePricingItem(props)

  return (
    <div
      className={`${styles['pricing-item']} ${
        isFeatured ? styles.featured : ''
      }`}
    >
      {isFeatured && (
        <div className={styles['pricing-badge']}>Most Popular</div>
      )}
      <div className={styles['pricing-icon']}>
        <i className={`bi bi-${icon}`}></i>
      </div>
      <h3>{planName}</h3>
      <div className={styles['price']}>
        <span className={styles['currency']}>$</span>
        {cost}
        <span className={styles['period']}>/year</span>
      </div>
      <p className={styles['description']}>{description}</p>
      <ul className={styles['features-list']}>
        {features.length ? (
          features.map((feature, i) => (
            <li
              key={`feature-${planName}-${i}`}
              className={feature.isProvided ? '' : styles.disabled}
            >
              <i
                className={`bi bi-${
                  feature.isProvided && feature.isSoon
                    ? 'clock-history'
                    : feature.isProvided
                      ? 'check2'
                      : 'x'
                }`}
              ></i>
              {feature.content}
              {feature.isSoon && <div className={styles.soon}>Soon</div>}
            </li>
          ))
        ) : (
          <div style={{ color: 'var(--footer-color)' }}>
            Nothing Found Here!
          </div>
        )}
      </ul>
      <button
        type='button'
        className={styles['btn-pricing']}
        onClick={(e) => {
          e.preventDefault()
          onSubscribeClick()
        }}
      >
        {btnLabel}
      </button>
    </div>
  )
}

export default memo(PricingItem)
